import { connect } from "react-redux"
import React, { Component } from 'react';
import './Common.css';
import './Splash.css';
import { changeTextInput, updateLoginStatus } from "../actions/betActions"
import imageScreenshot from '../screenshot.png';
import imageSecure from '../secure.jpg';
import imageSimple from '../simple.jpg';
import imageFree from '../balloons.jpg';

const stateMap = (store) => {
    return {
        textInputData: store.bet.textInputData,
        screenDimensions: store.bet.screenDimensions,
        ethAccount: store.bet.authentication.ethAccount
    };
};
class Splash extends Component {
    constructor(props) {
      super(props);

        // This binding is necessary to make `this` work in the callback
        this.changeTextInput = this.changeTextInput.bind(this);
        this.logIn = this.logIn.bind(this);
    }

    componentDidMount() {
        document.body.style.backgroundColor = "#ffffff";
    }

    componentWillUnmount() {
        document.body.style.backgroundColor = "#eeeeee";
    }

    changeTextInput(event) {
        this.props.dispatch(changeTextInput(event.target.name, event.target.value, "SPLASH"));
    }

    logIn(event) {
        this.props.dispatch(updateLoginStatus(true));
    }
  
    render() {

        let { width } = this.props.screenDimensions;
        let singleColumn =  width < 1200;

      return (
        <div>

          <div className="splashHeadlineSection">
            <div className="splashGroupHeadline">
                <div className="splashHeadline">Transform your arguments into bets</div>
                <div className="splashHeadlineText moveTop40">Securely bet against other Twitter users using the Ethereum blockchain.</div>
                <div className="moveTop40"><button className="btn btnSplash" onClick={this.logIn}>Get started</button></div>
            </div>
          </div>

          <div className="splashSection restrictSectionWidth">
            <div className={ singleColumn ? "splashGroupSingle restrictWidth": "splashGroupText padRightSplash"}>
                <div className="splashTitle">Blockchain betting made easy</div>
                <div className="labelInputGroup moveTop40">Bet real money against anyone, about anything</div>
                <div className="splashLightText moveTop5">We provide an easy to use bet enforcement and tracking platform 
                which leaves you in full control of the terms and amounts of your bets.</div>
                <div className="labelInputGroup moveTop20">Bets are secured by an Ethereum contract</div>
                <div className="splashLightText moveTop5">All bet rules are enforced on the Ethereum blockchain, 
                with an open source contract whose code available for public review.</div>
                <div className="labelInputGroup moveTop20">Bet against people you don't trust</div>
                <div className="splashLightText moveTop5">We use a system of incentives to ensure the outcome of your bet will be decided fairly even if you don't fully trust your opponent. 
                You never have to worry about your opponent not paying up, because all funds are deposited prior to the start of the bet.</div>
                <div className="labelInputGroup moveTop20">No middlemen, no extra fees</div>
                <div className="splashLightText moveTop5">Ethbet never has access to your money, and you never pay us any fees.
                You pay only the small fee required to use the Ethereum network.</div>
            </div>
            <div className={ singleColumn ? "splashGroupSingle": "splashGroupImg floatRight"}>
                <div className="fadeFrame"><img style={{top: 0}} className="splashImg fadeImg" src={imageScreenshot} alt="Handshake" /><div className="fadeEffect"></div></div>
            </div>
            <div className="clearFloat"></div>
          </div>

          <div style={{backgroundColor:"#fafafa"}} className="splashSection">
            <div className="restrictSectionWidth">
              <div className="splashGroupSingle">

                <div className="splashTitle">The betting process</div>
                <div className="labelInputGroup moveTop40">Agree to terms</div>
                <div className="splashLightText moveTop5">You create a bet proposal with all terms of the bet, 
                and send it to your opponent and an arbiter for review. They can approve, reject, or propose edits.</div>

                <div className="labelInputGroup moveTop20">Deposit funds to blockchain</div>
                <div className="splashLightText moveTop5">When everyone has agreed on terms,
                 the bet is deployed to the Ethereum blockchain as a publicly verifiable contract.
                 You and your opponent then deposit money into the contract. At this point   
                 no one can get money out of the contract unless either their opponent or the arbiter approves.</div>

                <div className="labelInputGroup moveTop20">Report the outcome</div>
                <div className="splashLightText moveTop5">When enough time has passed for you to know the outcome of the bet, 
                you report the outcome to the Ethereum contract.
                If you and your opponent report different outcomes either of you can request that the arbiter step in and settle the disagreement.
                We've created incentives[LINK] so that arbitration is rarely needed.</div>

                <div className="labelInputGroup moveTop20">Winner decided</div>
                <div className="splashLightText moveTop5">The Ethereum contract uses the participants' reported outcomes to decide the winner and
                 gives them permission to withdraw their money.</div>

              </div>
            </div>
          </div>

          <div style={{backgroundColor:"#fff"}} className="splashSection">
            <div className="restrictSectionWidth">
              <div className="splashGroupSingle">
                <div className="splashTitle">Ensuring fair outcomes</div>
                <div className="splashLightText moveTop40">We've created incentives so that people won't benefit from reporting false bet outcomes.
                There are two main components of our system: arbitration, and existing sources of reputation.</div>


                <div className="labelInputGroup moveTop20">Arbitration</div>
                <div className="splashLightText moveTop20"> 
                Our bet contracts are designed with three participants: two bettors and an arbiter. 
                When the bettors agree on the outcome the arbitor does nothing (and is not paid a fee). 
                When the bettors disagree the arbiter decides the outcome and the arbitor's fee is paid by the bettor
                who disagrees with the arbiter.</div> 
                
                <div className="splashLightText moveTop20">
                This system ensures that two of the three people involved would have to be dishonest to cause a bet with a clear outcome to be wrongly decided 
                or to cause an honest person to pay an arbitration fee. Even someone who loses a bet has an incentive to report their loss accurately to avoid
                having to pay an arbitration fee.
                </div>
                
                <div className="labelInputGroup moveTop20">Reputation</div>

                <div className="splashLightText moveTop20"> 
                                
                If someone lies about a bet outcome, the Ethereum blockchain will contain proof that the the lie came from their Ethereum address.
                
                We make it easy to associate someone's Ethereum address with their identity by requiring anyone who uses Ethbet to prove a two-way link between
                their Ethereum address and a Twitter username. We display these proofs on every user's public Ethbet profile. The more strongly associated someone's 
                Twitter account is with an identity that they care about, the less willing they'll be to create public proof of their dishonesty.</div>

                <div className="splashLightText moveTop20">
                 
                </div>
                <div className="splashLightText moveTop20"></div>
                <div className="splashLightText moveTop20"></div>
              </div>
            </div>
          </div>

          <div style={{backgroundColor:"#cbbde2"}} className="splashSection center">
            <div className="restrictSectionWidth">
              <div className="splashGroupSingle">
                <div className="splashTitle">insert another button for signing up</div>
                <div className="splashText moveTop40">.</div>
              </div>
            </div>
          </div>

          <div className="splashSection hide">
            { !singleColumn ? (
                <div className="splashGroupImg padRightSplash">
                    <div className="fadeFrame"><img style={{top: 0}} className="splashImg fadeImg" src={imageFree} alt="Free" /><div className="fadeEffect"></div></div>
                </div>
            ): "" }
            <div className={ singleColumn ? "splashGroupSingle": "splashGroupText"}>
                <div className="splashTitle">How it works</div>
                <div className="splashText moveTop40">We believe in a free, open internet.  That's why ethbet is open source and free to use.</div>
            </div>
            { singleColumn ? (
                <div className="splashGroupSingle">
                    <div className="fadeFrame"><img style={{top: 0}} className="splashImg fadeImg" src={imageFree} alt="Free" /><div className="fadeEffect"></div></div>
                </div>
            ): "" }
          </div>

          <div className="splashSection hide">
            <div className={ singleColumn ? "splashGroupSingle": "splashGroupText padRightSplash"}>
                <div className="splashTitle">Philosophy</div>
                <div className="splashText moveTop40">Testing</div>
            </div>
            <div className={ singleColumn ? "splashGroupSingle": "splashGroupImg floatRight"}>
                <div className="fadeFrame"><img style={{top: -30}} className="splashImg fadeImg" src={imageSimple} alt="Easy" /><div className="fadeEffect"></div></div>
            </div>
            <div className="clearFloat"></div>
          </div>

          <div className="splashSection hide">
            { !singleColumn ? (
                <div className="splashGroupImg padRightSplash">
                    <div className="fadeFrame"><img style={{top: -80}} className="splashImg fadeImg" src={imageSecure} alt="Secure" /><div className="fadeEffect"></div></div>
                </div>
            ): "" }
            <div className={ singleColumn ? "splashGroupSingle": "splashGroupText"}>
                <div className="splashTitle">It's secure.</div>
                <div className="splashText moveTop40">Secured by the power of the Ethereum blockchain.  Your funds and bet terms are held in a decentralized smart contract.  Participants can agree to cancel a bet any time to get your funds back.</div>
            </div>
            { singleColumn ? (
                <div className="splashGroupSingle">
                    <div className="fadeFrame"><img style={{top: -80}} className="splashImg fadeImg" src={imageSecure} alt="Secure" /><div className="fadeEffect"></div></div>
                </div>
            ): "" }
          </div>

       </div>
      );
    }
  }
  
  export default connect(stateMap)(Splash);



// WEBPACK FOOTER //
// ./src/components/Splash.js